import { RoutingConfiguration } from '~/features/workflow-routing/types';
import { everest } from '~/services/serviceInstances';

import {
  PatchRoutingConfigurationApiArg,
  ServerRoutingConfigurationResponse,
} from '../../types/routings/routing-configuration';

type Request = PatchRoutingConfigurationApiArg;
type ServerResponse = ServerRoutingConfigurationResponse;

export const patchRoutingConfiguration = async ({
  configInput,
}: Request): Promise<RoutingConfiguration> => {
  const response: ServerResponse = await everest.patch(
    '/routing-configuration',
    configInput,
  );

  return {
    id: response.data.id,
    allUserActivationStatus: response.data.allUserActivationStatus,
    instructions: response.data.instructions,
    fallbackResponse: response.data.fallbackResponse,
    firstActivationDate: response.data.firstActivationDate,
    lastActivationDate: response.data.lastActivationDate,
    createdDate: response.data.createdDate,
    modifiedDate: response.data.modifiedDate,
    createdById: response.data.createdById,
    modifiedById: response.data.modifiedById,
    versionNumber: response.data.versionNumber,
  };
};
